"use client";
import { BLOCKS_REGISTRY} from "./registry";
import type { StrapiBlock } from "./types";
import BlockErreur from "../BlockErreur";

///type Block = { id?: number | string; __component?: string; [k: string]: unknown };

export default function BlockManager({ blocks }: { blocks: StrapiBlock[] }) {
  if (!Array.isArray(blocks) || blocks.length === 0) return null;

  // Debug: Log all blocks and their component names
 // console.log('Blocks data:', blocks);

  return (
    <>
      {blocks.map((block, i) => {
        const Comp = block.__component
          ? BLOCKS_REGISTRY[block.__component]
          : undefined;

        const key = `${block.__component ?? "unknown"}-${
          block.documentId ?? block.id ?? i
        }`;

        if (!Comp) return <BlockErreur key={key} />;

        return <Comp key={key} data={block} />;
      })}
    </>
  );
}
